import { Button } from '@/shared/Button';
import React from 'react';
import { useRemoveOverlayGroup } from '@/components/FunctionalArea/Modal/RemoveOverlayGroupModal/hooks/useRemoveOverlayGroup';

export const RemoveOverlayGroupModal = (): React.ReactNode => {
  const { handleCancelRemove, handleRemoveAll, handleOrphanChildrenAndRemove } =
    useRemoveOverlayGroup();

  return (
    <div className="w-full border border-t-[#E1E0E6] bg-white p-[24px]">
      <form>
        <label className="text-sm font-semibold" htmlFor="overlayGroupName">
          Group contains data overlays. What would you like to do?
        </label>
        <div className="mt-10 flex items-center justify-between gap-5 text-center">
          <Button
            type="button"
            variantStyles="ghost"
            className="flex-1 justify-center"
            onClick={handleCancelRemove}
            data-testid="cancel-button"
          >
            Cancel
          </Button>
          <Button
            type="button"
            variantStyles="ghost"
            className="flex-1 justify-center"
            onClick={handleRemoveAll}
            data-testid="remove-button"
          >
            Remove overlays
          </Button>

          <Button
            type="button"
            className="flex-1 justify-center"
            onClick={handleOrphanChildrenAndRemove}
            data-testid="save-button"
          >
            Move overlays outside of the group
          </Button>
        </div>
      </form>
    </div>
  );
};
